import { render } from "./app-footer.vue?vue&type=template&id=66ca59e8"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=66ca59e8&lang=scss"

import exportComponent from "E:\\SonPhat\\Project\\Project_LenhDienTu\\CauHinhHoaDonDienTu_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__